<template>
    <div class="office-search-results-item">
        <p class="office-search-results-item-title">Interim HealthCare of {{officeName}}</p>
        <div class="office-search-results-item-ctas">
            <a class="office-search-results-item-external" target="_blank" v-on:click="pushDatalayer(item)" :href="item.CareersCtaLink">View Jobs</a> <span class="office-search-results-item-separator">|</span>
            <a class="office-search-results-item-info " :href="`${item.Url}`" v-on:click="pushDatalayer(item)">Office Information</a>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

	export default {
        props: ['item'],
        data: function() {
            return {
            }
        },
        methods: {
            pushDatalayer(item) {
                const isOffice = item.officeId !== null && item.officeId !== '' && item.officeId !== undefined && item.officeId !== 999;
				let type = 'Corporate';
				let officeID = '';
				let officeName = '';
				if (isOffice && officeName !== undefined) {
					type = `${officeName} Office`;
					officeID = `${item.officeId}`;
					officeName = `${item.HomeDisplayName}`;
				}
				window.dataLayer.push({
					event: 'career_interaction',
					branchType: type,
					branchID: '999',
					branchName: 'IHC Corporate',
					officeID,
					officeName
				});
            }
        },
        computed:  {
            officeName() {
                    return this.item.HomeDisplayName;
                }
            }
    }
</script>